import { Button, Result } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';

// Port từ license-cms/source/src/compoments/common/NotFound.js — giữ NGUYÊN chuỗi hiển thị
// (i18n notFound: notFoundMsg = 'Trang bạn đang tìm kiếm không tồn tại', goBack = 'Quay lại').
// Dựng bằng antd Result cho đồng bộ với chuẩn mreport-portal-site (bản cũ dùng markup + CSS riêng).
const NotFoundPage = () => (
    <Result
        status="404"
        title="404"
        subTitle="Trang bạn đang tìm kiếm không tồn tại"
        extra={
            <Link to="/">
                <Button className="go-back-btn" type="primary" size="large">
                    Quay lại
                </Button>
            </Link>
        }
    />
);

export default NotFoundPage;
